export const WebAuthCheck = (): boolean => {
    const webAuthSupported: boolean = !!window.PublicKeyCredential;
    return webAuthSupported;
}
